import useGetUserById from '../../../API/hooks/users/useGetUserById';
import GroupsSetting from '../../../components/GroupsSetting/GroupsSetting';

type Props = {
  fleetId: string;
  entityId: string | undefined;
  onClose: () => void;
};

function UserGroups({
  fleetId, entityId, onClose,
}: Props): JSX.Element {
  const { data: user } = useGetUserById(fleetId, entityId);
  return (
    <div>
      <GroupsSetting
        entity="user"
        entityId={entityId || ''}
        fleetId={fleetId}
        groups={user?.groups}
        onClose={onClose}
      />
    </div>
  );
}

export default UserGroups;
